export default "__VITE_ASSET__BvzzFdO0__"